export const initialUiState: UIState = {
  historyVisible: false,
  settingsVisible: false,
  keyboardVisible: true,
  undoButtonVisible: false,
};
